import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFeatureFlag } from 'types/system-settings.types';
import { initialMessage, userMessage } from 'constants/ui.constants';

interface IFeatureFlagsState {
	flags: IFeatureFlag[];
	loading: boolean;
	error: userMessage;
	successfullyUpdated: boolean;
}

const initialState: IFeatureFlagsState = {
	flags: [],
	loading: false,
	error: initialMessage,
	successfullyUpdated: false,
};

export const featureFlagsSlice = createSlice({
	name: 'featureFlags',
	initialState,
	reducers: {
		setFlags: (state, { payload }) => {
			state.flags = payload;
		},
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setError: (state, action: PayloadAction<userMessage>) => {
			state.error = action.payload;
		},
		setSuccessfullyUpdated: (state, { payload }) => {
			state.successfullyUpdated = payload;
		},
		updateSingleFlag: (state, { payload }) => {
			const flagIndex = state.flags.findIndex((flag) => flag.name === payload.name);
			if (flagIndex !== -1) {
				state.flags[flagIndex] = { ...state.flags[flagIndex], ...payload };
			}
		},
	},
});

export const getFlags = (state: any) => {
	return state.featureFlags.flags;
};

export const getLoading = (state: any) => {
	return state.featureFlags.loading;
};

export const getError = (state: any) => {
	return state.featureFlags.error;
};

export const getSuccessfullyUpdated = (state: any) => {
	return state.featureFlags.successfullyUpdated;
};

export const { setFlags, setLoading, setError, setSuccessfullyUpdated, updateSingleFlag } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
